import Image01 from './img/baby.jpg';
import Image02 from './img/busman.jpg';
import Image03 from './img/money.jpg';
import Image04 from './img/deer.jpg';
import Image05 from './img/dog.jpg';
import Image06 from './img/dogs.jpg';
import Image07 from './img/frog.jpg';
import Image08 from './img/godz.jpg';
import Image09 from './img/duck.jpg';
import Image10 from './img/jok.jpg';
import Image11 from './img/kill.jpg';
import Image12 from './img/com.jpg';
import Image13 from './img/man.jpg';
import Image14 from './img/boy.jpg';
import Image15 from './img/pok.jpg';
import Image16 from './img/dogi.jpg';
import Image17 from './img/stock.jpg';
import Image18 from './img/carton.jpg';

const Images = [Image01, Image02, Image03, Image04, Image05, Image06, Image07, Image08, Image09, Image10, Image11, Image12, Image13, Image14, Image15, Image16, Image17, Image18];
export default Images;